import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import App from '@supubwps-document-conversion/App'
import uploader from 'vue-simple-uploader'
import ElementUI from 'element-ui'
import router from '@supubwps-document-conversion/router'
import store from "@supubwps-document-conversion/store";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'element-ui/lib/theme-chalk/index.css'
import  '@comm/utils/filters.js'
// 导入云服务样式
import 'swiper/dist/css/swiper.min.css' 
import '@comm/styles/document-conversion/index.scss'
import { sha256 } from 'js-sha256'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Print from 'vue-print-nb'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
 Vue.use(Print);
Vue.prototype.$sha256 = sha256
promise.polyfill()
Vue.use(VueAwesomeSwiper)
Vue.use(uploader)
Vue.use(ElementUI)// 请求
Vue.config.productionTip = false
// import VueAMap from 'vue-amap'
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '2ccfed2c0d4b15cac4ddb206a1659032',
//   plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
//   v: '1.4.4',
//   uiVersion: '1.0'
// })


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// ./src/supubwps-document-conversion/main.js